/**
 * FAQ Accordion Functionality
 * Handles expanding/collapsing FAQ items with smooth animations
 */

class FAQAccordion {
  constructor() {
    this.faqItems = document.querySelectorAll('.faq-item');
    this.init();
  }

  init() {
    if (!this.faqItems.length) return;

    this.faqItems.forEach((item) => {
      const question = item.querySelector('.faq-question');
      if (!question) return;

      question.addEventListener('click', (e) => {
        e.preventDefault();
        this.toggleItem(item);
      });

      // Keyboard accessibility
      question.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          this.toggleItem(item);
        }
      });
    });

    // Optional: Close all items when clicking outside
    document.addEventListener('click', (e) => {
      if (!e.target.closest('.faq-item')) {
        // Uncomment the line below if you want to close all items when clicking outside
        // this.closeAllItems();
      }
    });
  }

  toggleItem(item) {
    const isActive = item.classList.contains('active');
    
    // Optional: Close other items when opening a new one (accordion behavior)
    // Comment out the next line if you want multiple items to be open at once
    this.closeAllItems();

    if (!isActive) {
      this.openItem(item);
    } else {
      this.closeItem(item);
    }
  }

  openItem(item) {
    const question = item.querySelector('.faq-question');
    const answer = item.querySelector('.faq-answer');
    
    if (!question || !answer) return;

    item.classList.add('active');
    question.setAttribute('aria-expanded', 'true');
    
    // Calculate actual height for smooth animation
    const content = answer.querySelector('.faq-answer-content');
    if (content) {
      answer.style.maxHeight = content.scrollHeight + 'px';
    }
  }

  closeItem(item) {
    const question = item.querySelector('.faq-question');
    const answer = item.querySelector('.faq-answer');
    
    if (!question || !answer) return;

    item.classList.remove('active');
    question.setAttribute('aria-expanded', 'false');
    answer.style.maxHeight = '0';
  }

  closeAllItems() {
    this.faqItems.forEach((item) => {
      this.closeItem(item);
    });
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new FAQAccordion();
  });
} else {
  new FAQAccordion();
}

// Re-initialize on Shopify section updates
if (typeof Shopify !== 'undefined' && Shopify.designMode) {
  document.addEventListener('shopify:section:load', () => {
    new FAQAccordion();
  });
}

